import CurriculumWidget from './components/CurriculumWidget.vue'

export default function () {
  return { component: CurriculumWidget }
}
